function handleFaqNavigation () {
    /*
        Handle faq navigation:
        if in faq category with anchor ID in url, open the relevant detail html element
    */
    const urlHash = window.location.hash.substr(1);
    if (urlHash) {
        const detailEl = document.getElementById(urlHash).querySelector('details');
        if (detailEl) {
            detailEl.open = true;
        }
    }
}



export { handleFaqNavigation };
